<span class="identificador-matriz-filial-input-group-text"
    [class.prepend]="prepend"
    [class.append]="append"
    [class.identificador-matriz]="config?.isMatriz"
    [class.identificador-filial]="config?.isFilial">
    {{identificador | identificadorMatrizFilial}}
</span>